import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/analytics";
import { GA_TRACKING_ID } from "../ga";

/**
 * Hook to automatically track page views when route changes
 * Usage: Add <PageTracking /> component in your App.jsx
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track if GA tracking ID is configured
    if (GA_TRACKING_ID) {
      trackPageView(location.pathname + location.search);
    }
  }, [location]);
};

/**
 * Component wrapper for page tracking
 * Add this inside your Router component
 */
export const PageTracking = () => {
  usePageTracking();
  return null;
};
